const indexData = [
  { title: '明星八卦追踪', desc: '最新明星动态、恋情曝光、绯闻实锤', count: '128条', icon: 'ri-star-line', color: 'primary' },
  { title: '综艺热点速递', desc: '热门综艺精彩cut、幕后花絮', count: '96条', icon: 'ri-tv-line', color: 'accent' },
  { title: '网红达人动态', desc: '网红圈大事件、带货翻车合集', count: '84条', icon: 'ri-user-smile-line', color: 'primary' },
  { title: '影视吐槽合集', desc: '热播剧槽点、穿帮镜头大盘点', count: '73条', icon: 'ri-film-line', color: 'accent' },
  { title: '音乐圈新鲜事', desc: '歌手新歌首发、抄袭争议追踪', count: '65条', icon: 'ri-music-line', color: 'primary' },
  { title: '体育八卦速报', desc: '运动员近况追踪、转会内幕', count: '58条', icon: 'ri-basketball-line', color: 'accent' },
  { title: '平台政策解读', desc: '短视频平台新规、算法调整', count: '47条', icon: 'ri-smartphone-line', color: 'primary' },
  { title: '社会热点聚焦', desc: '全网热议的社会话题深度梳理', count: '42条', icon: 'ri-fire-line', color: 'accent' },
  { title: '黑料每日大赛', desc: '每日精选大赛视频合集', count: '36条', icon: 'ri-trophy-line', color: 'primary' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">专题索引</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            快速浏览全部内容板块，找到你最感兴趣的话题
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexData.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-start gap-4 bg-background-100 border border-background-300/30 rounded-xl p-4 md:p-5 transition-all hover:border-primary-500/20 hover:bg-background-200/50 cursor-pointer"
            >
              <div className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center ${
                item.color === 'primary' ? 'bg-primary-500/10' : 'bg-accent-500/10'
              }`}>
                <i className={`${item.icon} text-lg ${
                  item.color === 'primary' ? 'text-primary-400' : 'text-accent-400'
                }`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="text-sm font-heading font-bold text-foreground-900 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}</span>
                </div>
                <p className="mt-1 text-xs text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}